import { render, staticRenderFns } from "./BillingPaywall.vue?vue&type=template&id=70d11b8a"
import script from "./BillingPaywall.vue?vue&type=script&lang=js"
export * from "./BillingPaywall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports